import TaxDownloadCard from './TaxDownloadCard'

export default TaxDownloadCard
